import React from "react";
import LeadStatusBadge from "./LeadStatusBadge";
import PriorityBadge from "./PriorityBadge";

function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const now = new Date();
  const opts =
    d.getFullYear() === now.getFullYear()
      ? { month: "short", day: "numeric" }
      : { month: "short", day: "numeric", year: "numeric" };
  return new Intl.DateTimeFormat("en-US", opts).format(d);
}

export default function LeadsTable({ leads, selectedId, onSelect }) {
  return (
    <table className="leads-table">
      <thead>
        <tr>
          <th className="col-date">Created</th>
          <th className="col-name">Name</th>
          <th className="col-company">Company</th>
          <th className="col-status">Status</th>
        </tr>
      </thead>
      <tbody>
        {leads.map((lead) => (
          <tr
            key={lead.id}
            className={lead.id === selectedId ? "selected" : ""}
            onClick={() => onSelect(lead.id)}
          >
            <td className="col-date">{formatDate(lead.created_at)}</td>
            <td className="col-name">
              <span className="lead-name">
                {lead.first_name} {lead.last_name}
              </span>
              <PriorityBadge priority={lead.priority} />
            </td>
            <td className="col-company">{lead.company || "—"}</td>
            <td className="col-status">
              <LeadStatusBadge leadStatus={lead.lead_status || "new"} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
